import { render, staticRenderFns } from "./MbGrid.vue?vue&type=template&id=a71e86a8&scoped=true&"
import script from "./MbGrid.vue?vue&type=script&lang=js&"
export * from "./MbGrid.vue?vue&type=script&lang=js&"
import style0 from "./MbGrid.vue?vue&type=style&index=0&id=a71e86a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71e86a8",
  null
  
)

export default component.exports